module.exports = __webpack_public_path__ + "media/components/lesson4/common/statics/image3-b5b6a4175313fd7c2e758b8d2a21001a.jpg";